var _excluded = ["label", "description", "invalid", "status", "index", "stepsAmount", "variant"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { useMultiStyleConfig } from '../../../../utils/use-style-config';
import { _IconIndicator, Box } from '../../../internal';
import { Description, Indicator, Title } from './components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TrackerStep = _ref => {
  var {
    label,
    description,
    invalid,
    status,
    index,
    stepsAmount,
    variant
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  var isDone = status === 'done';
  var isActive = status === 'active';
  var isComplete = status === 'complete';
  var isFirstStep = index < 1;
  var isLastStep = stepsAmount === index + 1;
  var isInvalid = !!(invalid !== null && invalid !== void 0 && invalid.isInvalid);
  var statusIcon = variant === 'horizontal' && isInvalid ? /*#__PURE__*/_jsx(_IconIndicator, {
    variant: "warning",
    tooltip: {
      label: invalid.message
    }
  }) : undefined;
  var styles = useMultiStyleConfig('TrackerStep', {
    variant,
    isDone,
    isActive,
    isComplete,
    isFirstStep,
    isLastStep
  });
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    "data-component": "TrackerStep",
    __css: styles['stepContainer']
  }, props), {}, {
    children: [!isLastStep && /*#__PURE__*/_jsx(Box, {
      __css: styles['connector']
    }), /*#__PURE__*/_jsxs(Box, {
      __css: styles['grid'],
      children: [/*#__PURE__*/_jsx(Indicator, {
        isActive: isActive,
        isDone: isDone || isComplete
      }), /*#__PURE__*/_jsx(Title, {
        label: label,
        variant: variant,
        isReadOnly: !isActive && !isDone && !isComplete,
        isInvalid: isInvalid
      }), /*#__PURE__*/_jsx(Description, {
        label: description,
        variant: variant,
        statusIcon: statusIcon
      })]
    })]
  }));
};
TrackerStep.displayName = 'TrackerStep';
//# sourceMappingURL=TrackerStep.js.map